export const FIELD_TYPE = {
  TEXT: "TEXT",
  LONG_TEXT: "LONG_TEXT",
  LINK: "LINK",
  NUMBER: "NUMBER",
  DATE: "DATE",
  YES_NO: "YES_NO",
  SINGLE_SELECT: "SINGLE_SELECT",
  MULTI_SELECT: "MULTI_SELECT",
  PERSON: "PERSON",
};

export const COLUMN_TYPE = {
  text: "text",
  longText: "longtext",
  link: "link",
  number: "number",
  singleSelect: "select",
  multiSelect: "multiselect",
  person: "person",
  date: "date",
  yesNo: "boolean",
};

export const FIELD_TYPES = [
  {
    id: COLUMN_TYPE.text,
    label: "Text",
    description: "A few words on one line",
  },
  {
    id: COLUMN_TYPE.longText,
    label: "Long Text",
    description: "A sentence or paragraph, wrapped in the cell",
  },
  {
    id: COLUMN_TYPE.link,
    label: "Link",
    description: "A URL, shown as clickable text",
  },
  {
    id: COLUMN_TYPE.number,
    label: "Number",
    description:
      "Digits only, with a format you choose: percent, currency or a custom label",
    hasNumberFormat: true,
  },
  {
    id: COLUMN_TYPE.singleSelect,
    label: "Single Select",
    description: "One value from a list you set, as a coloured tag",
    hasValues: true,
  },
  {
    id: COLUMN_TYPE.multiSelect,
    label: "Multi Select",
    description: "One or more values from a list you set",
    hasValues: true,
  },
  {
    id: COLUMN_TYPE.person,
    label: "Person",
    description: "One or more people in the workspace",
  },
  {
    id: COLUMN_TYPE.date,
    label: "Date",
    description: "A single date",
  },
  {
    id: COLUMN_TYPE.yesNo,
    label: "Yes/No",
    description: "One of two values: Yes or No",
  },
];

export const NUMBER_FORMAT = {
  number: "number",
  percent: "percent",
  currency: "currency",
  custom: "custom",
  none: "none",
};

export const NUMBER_FORMATS = [
  { id: NUMBER_FORMAT.number, label: "Number" },
  { id: NUMBER_FORMAT.percent, label: "Percent" },
  { id: NUMBER_FORMAT.currency, label: "Currency" },
  { id: NUMBER_FORMAT.custom, label: "Custom Label" },
  { id: NUMBER_FORMAT.none, label: "None" },
];

export const UNIT_POSITION = {
  before: "before",
  after: "after",
};

export const UNIT_POSITIONS = [
  { id: UNIT_POSITION.before, label: "Before" },
  { id: UNIT_POSITION.after, label: "After" },
];

export const MAX_UNIT_LENGTH = 32;

export const fieldTypeOf = (type) =>
  FIELD_TYPES.find(({ id }) => id === type) ?? FIELD_TYPES[0];

export const hasValues = (type) =>
  type === COLUMN_TYPE.singleSelect || type === COLUMN_TYPE.multiSelect;

export const hasNumberFormat = (type) => type === COLUMN_TYPE.number;
